export const API_KEY = "jdfnjdnfkg56jkdfkgmdm4545kgnn";
export const API_SECRET = "snfmdksmglre654k7umggsmem56k5jkm";
// export const BASEURL = import.meta.env.VITE_API_BACKEND_URL;
export const BASEURL = "https://api.motoioi.com/";
// export const BASEURL = "https://common-api.mytrial.in/";